import moment from "moment";

/**
 *
 * Checks if end date is more than 2 weeks from current end date in future or past
 * @param {string} currentEndDate
 * @param {string} endDate
 * @returns {boolean} - Returns true if the end date is more than 2 weeks from the current end date, otherwise false
 */

export const isEndDateMoreThanTwoWeeks = (currentEndDate, endDate) => {
  // Convert the dates to moment objects
  const currentEndDateMoment = moment(currentEndDate);
  const endDateMoment = moment(endDate);

  // Calculate the difference in days
  const diffInDays = endDateMoment.diff(currentEndDateMoment, "days");

  // Check if the difference is more than 14 days (2 weeks) in either direction
  return Math.abs(diffInDays) > 14;
};

export const getDefaultEndDate = ({ currentEndDate, campaignDuration }) => {
  if (!campaignDuration) {
    return currentEndDate;
  }

  if (!currentEndDate) {
    const today = moment().startOf("day");
    return today.add(campaignDuration, "days").format("YYYY-MM-DD");
  }

  return currentEndDate;
};
